@if (group) {
  <ng-container [formGroup]="group">
    <ng-container *ngTemplateOutlet="formField"></ng-container>
  </ng-container>
}

@if (!group) {
  <ng-container *ngTemplateOutlet="formField"></ng-container>
}

<ng-template #formField>
  <!-- <div class="container"> -->
  <div>
    <div class="toggle-container">
      @if (icon != null) {
        <mat-icon>{{ icon }}</mat-icon>
      }
      <mat-slide-toggle #toggle="matSlideToggle" checked="checked" [formControl]="control" [aria-label]="label"></mat-slide-toggle>
      @if (capitalizeLabel) {
        <span class="subtitle2"> {{ label | capitalizefirst }}</span>
      }
      @if (!capitalizeLabel) {
        <span class="subtitle2"> {{ label }}</span>
      }
      @if (tooltip != null) {
        <!-- a button so keyboard users can reach the info too: Material shows the tooltip on focus, and screen readers read it as the button's description -->
        <button
          type="button"
          class="button-reset info-button"
          [attr.aria-label]="sysText.moreInformation_ariaLabel"
          [matTooltip]="tooltip"
          [matTooltipShowDelay]="500"
          matTooltipPosition="above">
          <mat-icon class="button-icon">info_outline</mat-icon>
        </button>
      }
    </div>
    @if (hint) {
      <mat-hint class="hint-error" [ngClass]="{ highlight: isHintHighlighted, warn: isHintWarning }">{{ hint }}</mat-hint>
    }
    <div aria-live="polite">
      @if (control.errors?.msError) {
        <mat-error class="hint-error">{{ control.errors?.msError }}</mat-error>
      }
      @if (control.errors?.required) {
        <mat-error class="hint-error">{{ sysText.required | capitalizefirst }}</mat-error>
      }
    </div>
  </div>
</ng-template>
